import { atom } from "nanostores";
import posthog from "posthog-js";

if (!import.meta.env.SSR) {
  posthog.init("phc_3k3DLmq6py0js8iUo8vLkXReb4WK7fbag8NWenb6XAE", {
    api_host: "https://us.i.posthog.com",
    person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
    disable_session_recording: import.meta.env.DEV,
  });
}

export const $posthog = atom(posthog);
